import { CloseOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Col, Form, Input, Row, Select, Switch, Tooltip } from 'antd';
import React from 'react';
import {
  TOOLTIP_Z_INDEX,
  TOY_CONTENT_LIST_LIMIT,
} from '../../../../../common/constants';
import ColumnTitleWithInfo from '../../../../../components/ColumnTitleWithInfo';
import { formValidatorRules } from '../../../../../common/utils';

const { required } = formValidatorRules;

const COLS = {
  text: { xs: 24, sm: 12, md: 9 },
  expected: { xs: 24, sm: 12, md: 5 },
  isBlocking: { xs: 12, sm: 6, md: 4 },
  isArchived: { xs: 12, sm: 6, md: 3 },
  remove: { xs: 12, sm: 6, md: 3 },
};

const EXPECTED_OPTIONS = [
  { label: 'Yes', value: true },
  { label: 'No', value: false },
];

const ToyChecklist = ({ isView }) => (
  <Form.Item className="toy-content-section" label="Checklist">
    <Form.List name="checklist">
      {(fields, { add, remove }) => (
        <>
          {fields?.map(({ key, name, ...restField }) => (
            <Row key={key} gutter={[8, 0]} className="toy-content-row">
              <Col {...COLS?.text}>
                <Form.Item
                  {...restField}
                  name={[name, 'text']}
                  label="Question"
                  rules={[{ ...required, message: 'Please Enter Question!' }]}
                >
                  <Input
                    allowClear
                    placeholder="Enter Question"
                    maxLength={200}
                  />
                </Form.Item>
              </Col>
              <Col {...COLS?.expected}>
                <Form.Item
                  {...restField}
                  name={[name, 'expected']}
                  label="Expected Answer"
                >
                  <Select
                    allowClear
                    placeholder="Select Expected Answer"
                    options={EXPECTED_OPTIONS}
                  />
                </Form.Item>
              </Col>
              <Col {...COLS?.isBlocking}>
                <Form.Item
                  {...restField}
                  name={[name, 'isBlocking']}
                  label={
                    <ColumnTitleWithInfo
                      title="Mark Damaged"
                      info={
                        <>
                          <div>
                            <strong>On:</strong> if the answer does not match
                            the expected answer, the toy unit is marked as
                            damaged.
                          </div>
                          <div className="mt-10">
                            <strong>Off:</strong> the answer is only recorded,
                            the toy unit is not marked as damaged.
                          </div>
                        </>
                      }
                      zIndex={TOOLTIP_Z_INDEX}
                    />
                  }
                  htmlFor=""
                  valuePropName="checked"
                  initialValue={false}
                >
                  <Switch size="small" />
                </Form.Item>
              </Col>
              <Col {...COLS?.isArchived}>
                <Form.Item
                  {...restField}
                  name={[name, 'isArchived']}
                  label="Archived"
                  htmlFor=""
                  valuePropName="checked"
                  initialValue={false}
                >
                  <Switch size="small" />
                </Form.Item>
              </Col>
              <Col {...COLS?.remove} className="toy-content-remove">
                <Tooltip title="Remove" placement="top" zIndex={4}>
                  <Button type="link" disabled={isView}>
                    <CloseOutlined onClick={() => remove(name)} />
                  </Button>
                </Tooltip>
              </Col>
            </Row>
          ))}
          {fields?.length < TOY_CONTENT_LIST_LIMIT && (
            <Form.Item>
              <Button
                type="dashed"
                onClick={() => add({ isBlocking: false, isArchived: false })}
                block
                icon={<PlusOutlined />}
              >
                Add Checklist Item
              </Button>
            </Form.Item>
          )}
        </>
      )}
    </Form.List>
  </Form.Item>
);

export default ToyChecklist;
